// flow weak
import React, { Component, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Modal,
  Form,
  Table,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Redirect, Link } from "react-router-dom";
import { withRouter } from "react-router";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "./dashboard.scss";
import {
  currentDealList,
  upcomingDealList,
  subscribeUser,
} from "../../../redux/actions/frontActions";
import { getSiteStatus } from "../../../redux/actions/siteActions";
import { listPostup } from "../../../redux/actions/postupActions";
import noImg from "../../../img/no_img.jpg";
import noRecordFound from "../../../img/no-record-found.png";
import "react-responsive-tabs/styles.css";
import Timer from "./Timer";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import ReactHtmlParser from "react-html-parser";
import Reviews from "./Reviews.js";
import Question from "./Question.js";
import ReviewList from "./ReviewList.js";
import Cookies from "universal-cookie";
import auth from "../../../services/auth";
import moment from "moment";
import { appConfig } from "../../../config";
import DatePicker from "react-date-picker";
import languageConfig from "../../../config/languageConfig";
import UseDfpSlot from "./UseDfpSlot";
import ScriptSlot from "./ScriptSlot";

const cookies = new Cookies();


let now = moment();
const history = createBrowserHistory();
let isLoading = false,
  limitFeature = 26,
  limitSlider = 25,
  limit = 24;
window.googletag = window.googletag || { cmd: [] };
function Currency(props) {
  const cur = props.default_currency == "EUR" ? "€" : "$";
  return (
    <span className={props.className}>
      {props.default_lang == "en" ? cur : ""}
      {props.amount}
      {props.default_lang == "fr" ? cur : ""}
    </span>
  );
}

class Dashboard extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList: "",
      currentDeals: [],
      currentDeals2: [],
      limit: 24,
      perPage: 24,
      total: "",
      utotal: "",
      topDealHighlights: "",
      button_color: "",
      text_color: "",
      mouseover_color: "",
      default_city: "",
      siteDomain: "",
      wdith: 0,
      height: 0,
      notifications: "",
      sending: false,
      pending_offers: "",
      upDeal: "",
      notFoundPopup: false,
      email: "",
      emailError: "",
      sub_email: "",
      sub_emailError: "",
      zipcode: "",
      zipcodeError: "",
      dob: "",
      dobError: "",
      removePopup: true,
      hover: false,
      featured_offer: "",
      multi_lang: "no",
      lang: "",
      default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
      load_more: false,
      currency: "",
      symbol: "",
      slider: "0",
      NoRecord: "",
      siteName: "",
      Optin: "0",
      fb_link: "",
      post_up: 0,
      fontFamilies: "",
      postupList: [],
      PopupDealEndsubscrbe: "enable",
      third_position: [],
      top_position: [],
      siteStatus: "",
      themeData: "",
      curDeal: "",
      topDeal: "",
      topDealHighlights: "",
      removePopup: true,
      sending: false,
      curDealData: "",
      upcomingDeal: "",
      error: "",
      loadAds: false,
      upcominglink :"disable",
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.pagination = this.pagination.bind(this);
    this.paginationupdeal = this.paginationupdeal.bind(this);
    this.submitOptinForm = this.submitOptinForm.bind(this);
    this.onChangeDOBDate = this.onChangeDOBDate.bind(this);
    this.loadAdsScript = this.loadAdsScript.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  hoverOn = (e) => {
    this.setState({
      hover: true,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  hoverOff = (e) => {
    this.setState({
      hover: false,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  getValidUrl = (url = "") => {
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, "");

    if (/^(:\/\/)/.test(newUrl)) {
      return `http${newUrl}`;
    }
    if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
      return `http://${newUrl}`;
    }

    return newUrl;
  };

  loadAdsScript = () => {
    this.setState({ loadAds: true });
  };

  closenotFoundPopup = () => {
    this.setState({ removePopup: false, total: "", utotal: "" });
  };
  pagination = () => {
    // isLoading = true;
    this.setState({ load_more: true });
    if (
      this.state.notifications == "" &&
      this.state.fb_link == null &&
      this.state.Optin == 0 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 0
    ) {
      limitSlider = limitSlider + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link != null &&
      this.state.Optin == 0 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 0
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link == null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 0
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications == "" &&
      this.state.fb_link != null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 0
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link != null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 0
    ) {
      limitSlider = limitSlider + this.state.perPage;
    } else if (
      this.state.notifications == "" &&
      this.state.fb_link == null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 1
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link == null &&
      this.state.Optin == 0 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 1
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications == "" &&
      this.state.fb_link != null &&
      this.state.Optin == 0 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 1
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications == "" &&
      this.state.fb_link != null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 1
    ) {
      limitSlider = limitSlider + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link == null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 1
    ) {
      limitSlider = limitSlider + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link != null &&
      this.state.Optin == 0 &&
      this.state.featured_offer == 1 &&
      this.state.slider == 1
    ) {
      limitSlider = limitSlider + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link == null &&
      this.state.Optin == 0 &&
      this.state.featured_offer == 0
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications == "" &&
      this.state.fb_link != null &&
      this.state.Optin == 0 &&
      this.state.featured_offer == 0
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications == "" &&
      this.state.fb_link == null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 0
    ) {
      limitFeature = limitFeature + this.state.perPage;
    } else if (
      this.state.notifications == "" &&
      this.state.fb_link != null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 0
    ) {
      limitSlider = limitSlider + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link == null &&
      this.state.Optin == 1 &&
      this.state.featured_offer == 0
    ) {
      limitSlider = limitSlider + this.state.perPage;
    } else if (
      this.state.notifications != "" &&
      this.state.fb_link != null &&
      this.state.Optin == 0 &&
      this.state.featured_offer == 0
    ) {
      limitSlider = limitSlider + this.state.perPage;
    } else {
      limit = limit + this.state.perPage;
    }
    const postData = {
      limit:
        this.state.notifications == "" &&
        this.state.fb_link == null &&
        this.state.Optin == 0 &&
        this.state.featured_offer == 1 &&
        this.state.slider == 0
          ? limitSlider
          : this.state.notifications != "" &&
            this.state.fb_link != null &&
            this.state.Optin == 0 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 0
          ? limitFeature
          : this.state.notifications != "" &&
            this.state.fb_link == null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 0
          ? limitFeature
          : this.state.notifications == "" &&
            this.state.fb_link != null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 0
          ? limitFeature
          : this.state.notifications != "" &&
            this.state.fb_link != null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 0
          ? limitSlider
          : this.state.notifications == "" &&
            this.state.fb_link == null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 1
          ? limitFeature
          : this.state.notifications != "" &&
            this.state.fb_link == null &&
            this.state.Optin == 0 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 1
          ? limitFeature
          : this.state.notifications == "" &&
            this.state.fb_link != null &&
            this.state.Optin == 0 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 1
          ? limitFeature
          : this.state.notifications == "" &&
            this.state.fb_link != null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 1
          ? limitSlider
          : this.state.notifications != "" &&
            this.state.fb_link == null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 1
          ? limitSlider
          : this.state.notifications != "" &&
            this.state.fb_link != null &&
            this.state.Optin == 0 &&
            this.state.featured_offer == 1 &&
            this.state.slider == 1
          ? limitSlider
          : this.state.notifications != "" &&
            this.state.fb_link == null &&
            this.state.Optin == 0 &&
            this.state.featured_offer == 0
          ? limitFeature
          : this.state.notifications == "" &&
            this.state.fb_link != null &&
            this.state.Optin == 0 &&
            this.state.featured_offer == 0
          ? limitFeature
          : this.state.notifications == "" &&
            this.state.fb_link == null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 0
          ? limitFeature
          : this.state.notifications == "" &&
            this.state.fb_link != null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 0
          ? limitSlider
          : this.state.notifications != "" &&
            this.state.fb_link == null &&
            this.state.Optin == 1 &&
            this.state.featured_offer == 0
          ? limitSlider
          : this.state.notifications != "" &&
            this.state.fb_link != null &&
            this.state.Optin == 0 &&
            this.state.featured_offer == 0
          ? limitSlider
          : limit,
      cityID: this.state.default_city,
      geolocation: "off",
      giftvoucher: "no",
      lang: this.state.default_lang,
    };
    this.props.currentDealList(postData);
  };

  paginationupdeal = () => {
    // isLoading = true;
    this.setState({ load_more: true });
    limit = limit + this.state.perPage;
    const postData = {
      limit: limit,
      cityID: this.state.default_city,
      geolocation: "off",
      giftvoucher: "no",
      lang: this.state.default_lang,
    };
    if (this.state.pending_offers == "enable") {
      this.props.upcomingDealList(postData);
    }
  };

  handlePageChange = (page) => {
    isLoading = true;
    this.setState({
      currentPage: this.state.currentPage,
      sending: true,
    });
    let default_city = this.state.default_city;
    let pending_offers = this.state.pending_offers;
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (
      !this.state.default_city ||
      this.state.default_city != siteData.default_city
    ) {
      if (siteData && siteData.default_city) {
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          featured_offer: siteData.featured_offer,
          slider: siteData.slider,
          siteName: siteData.siteName,
          Optin: siteData.Optin,
          post_up: siteData.postup,
        });
        default_city = siteData.default_city;
      }
    }

    if (siteData && siteData.pending_offers) {
      pending_offers = siteData.pending_offers;
      this.setState({ pending_offers: siteData.pending_offers });
    }
    const postData = {
      page: this.state.currentPage,
      limit:
        siteData.notifications == "" &&
        siteData.fb_link == null &&
        siteData.Optin == 0 &&
        siteData.featured_offer == 1 &&
        siteData.slider == 0
          ? 25
          : siteData.notifications != "" &&
            siteData.fb_link != null &&
            siteData.Optin == 0 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 0
          ? 26
          : siteData.notifications != "" &&
            siteData.fb_link == null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 0
          ? 26
          : siteData.notifications == "" &&
            siteData.fb_link != null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 0
          ? 26
          : siteData.notifications != "" &&
            siteData.fb_link != null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 0
          ? 25
          : siteData.notifications == "" &&
            siteData.fb_link == null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 1
          ? 26
          : siteData.notifications != "" &&
            siteData.fb_link == null &&
            siteData.Optin == 0 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 1
          ? 26
          : siteData.notifications == "" &&
            siteData.fb_link != null &&
            siteData.Optin == 0 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 1
          ? 26
          : siteData.notifications == "" &&
            siteData.fb_link != null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 1
          ? 25
          : siteData.notifications != "" &&
            siteData.fb_link == null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 1
          ? 25
          : siteData.notifications != "" &&
            siteData.fb_link != null &&
            siteData.Optin == 0 &&
            siteData.featured_offer == 1 &&
            siteData.slider == 1
          ? 25
          : siteData.notifications != "" &&
            siteData.fb_link == null &&
            siteData.Optin == 0 &&
            siteData.featured_offer == 0
          ? 26
          : siteData.notifications == "" &&
            siteData.fb_link != null &&
            siteData.Optin == 0 &&
            siteData.featured_offer == 0
          ? 26
          : siteData.notifications == "" &&
            siteData.fb_link == null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 0
          ? 26
          : siteData.notifications == "" &&
            siteData.fb_link != null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 0
          ? 25
          : siteData.notifications != "" &&
            siteData.fb_link == null &&
            siteData.Optin == 1 &&
            siteData.featured_offer == 0
          ? 25
          : siteData.notifications != "" &&
            siteData.fb_link != null &&
            siteData.Optin == 0 &&
            siteData.featured_offer == 0
          ? 25
          : this.state.limit,
      giftvoucher: "no",
    };

    if (default_city) {
      postData.cityID = cookies.get("akash")
        ? cookies.get("akash")
        : default_city;
    }
    if (siteData && siteData.default_lang) {
      postData.lang = this.state.default_lang
        ? this.state.default_lang
        : siteData.default_lang;
    }
    if (!isEmpty(this.props.match.params) && this.props.match.params.cityID) {
      postData.geolocation = "off";
    }

    if (this.state.geoCityId != this.state.default_city) {
      postData.geolocation = "off";
    }
    this.props.currentDealList(postData);
    if (pending_offers == "enable") {
      this.props.upcomingDealList(postData);
    }
  };

  onSearch = (val) => {
    this.handleSearch(val);
  };

  handleSearch(val) {
    const postData = {
      page: this.state.currentPage,
      latitude: this.props.coords ? this.props.coords.latitude : "26.846695",
      longitude: this.props.coords ? this.props.coords.longitude : "80.946167",
      search: val,
      geolocation: "off",
      giftvoucher: "no",
      lang: this.state.default_lang,
      cityID: this.state.default_city,
    };
    if (val.length !== 0) {
      this.props.currentDealList(postData);
    } else {
      this.handlePageChange();
    }
  }
  componentWillMount() {
    isLoading = true;


    this.props.listPostup({ page: 0 }, "postup-list/all");
    if (typeof jQuery != "undefined") {
      //console.log("Jquery Version", jQuery.fn.jquery);
    } else {
     // console.log("No jquery");
    }
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
  
    if (this.props.match.params && this.props.match.params.cityID) {
      this.setState({
        default_city: this.props.siteStatus.default_city, //this.props.match.params.cityID,
        post_up: siteData.postup,

      });
    }

    isLoading = false;
  }


  componentDidMount() {


    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    let top_position = [];
    let third_position = [];
    if (siteData) {
      this.setState({ siteDomain: siteData.siteDomain });
            this.setState({ upcominglink: siteData.upcominglink });
      this.setState({ fontFamilies: siteData.font_families });
      if (siteData.default_city) {
        top_position = siteData.notifications.filter(
          (data) => data.position == "top"
        );
        third_position = siteData.notifications.filter(
          (data) => data.position == "third_position"
        );
        third_position = third_position[0] ? third_position[0] : third_position;
        this.setState({
          siteStatus: siteData,
          default_city: siteData.default_city,
          featured_offer: siteData.featured_offer,
          notifications: siteData.notifications,
          geoCityId:
            siteData.country && siteData.country.default_geo_city
              ? siteData.country.default_geo_city
              : "",
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
          slider: siteData.slider,
          siteName: siteData.siteName,
          Optin: siteData.Optin,
          post_up: siteData.postup,
          PopupDealEndsubscrbe: siteData.PopupDealEndsubscrbe,
          top_position: top_position,
          third_position: third_position,
        });
      }
    } else {
      // this.props.getSiteStatus();
    }
    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          text_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
      if (siteData.default_lang == "fr") {
        this.setState({ NoRecord: this.props.themeData.french_NoRecord });
      } else {
        this.setState({ NoRecord: this.props.themeData.NoRecord });
      }
      this.setState({ fb_link: this.props.themeData.fb_link });
    }
    this.handlePageChange(1);
    let userIDParams = this.props.match.params.user_ID
      ? this.props.match.params.user_ID
      : "";
    let Link = this.props.match.url;
    if (userIDParams !== "") {
      const token = auth.getToken();
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);

      cookies.set("referredBy", userIDParams, { path: "/", expires: d });

      let url = appConfig.site.siteurl;
      cookies.set("referredLink", url + "" + Link, { path: "/", expires: d });
      let referredLink = cookies.get("referredLink");

      this.context.router.history.push({ pathname: "/" });

      if (token !== null) {
        let d = new Date();
        d.setTime(d.getTime() + 480 * 60 * 1000);
      }
    }

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);

    if (this.props.themeData.menu_bar) {
      this.setState({
        menuBgStyles: {
          backgroundColor: this.props.themeData.menu_bar.menu_bar_color,
        },
      });
    } else {
      this.setState({
        menuBgStyles: {
          backgroundColor: "",
        },
      });
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  handleLanguageChange(lang) {
    isLoading = true;
    this.setState({
      currentPage: this.state.currentPage,
      sending: true,
    });
    let default_city = this.state.default_city;
    let pending_offers = this.state.pending_offers;
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    if (
      !this.state.default_city ||
      this.state.default_city != siteData.default_city
    ) {
      if (siteData && siteData.default_city) {
        let top_position = siteData.notifications.filter(
          (data) => data.position == "top"
        );
        let third_position = siteData.notifications.filter(
          (data) => data.position == "third_position"
        );
        third_position = third_position[0] ? third_position[0] : third_position;
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          pending_offers: siteData.pending_offers,
          featured_offer: siteData.featured_offer,
          slider: siteData.slider,
          siteName: siteData.siteName,
          Optin: siteData.Optin,
          post_up: siteData.postup,
          PopupDealEndsubscrbe: siteData.PopupDealEndsubscrbe,
          top_position: top_position,
          third_position: third_position,
        });
        default_city = siteData.default_city;
        pending_offers = siteData.pending_offers;
      }
    }

    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      giftvoucher: "no",
    };

    if (default_city) {
      postData.cityID = default_city;
    }
    if (this.state.default_lang) {
      postData.lang = lang;
    }
    if (!isEmpty(this.props.match.params) && this.props.match.params.cityID) {
      postData.geolocation = "off";
    }

    if (this.state.geoCityId != this.state.default_city) {
      postData.geolocation = "off";
    }
    this.props.currentDealList(postData);
    if (pending_offers == "enable") {
      this.props.upcomingDealList(postData);
    }
  }

  componentWillReceiveProps(nextProps) {
    // let channel = this.props.pusher.subscribe('payvibe-channel');
    // channel.bind("inv-event", (data) => {
    //   console.log('data---', data)
    // });
    // this.props.pusher.connection.bind( 'error', function( err ) {
    //   console.log('err--', err)
    // });
    let lang = this.state.default_lang ? this.state.default_lang : "en";
    if (
      this.props.match.params &&
      this.props.match.params.cityID &&
      this.state.default_city
    ) {
      if (this.props.match.params.cityID != this.state.default_city) {
        isLoading = true;
      }
    }

    if (nextProps.language) {
      if (this.state.default_lang !== nextProps.language) {
        lang = nextProps.language;
        isLoading = false;
        this.setState({ default_lang: nextProps.language });
        this.handleLanguageChange(nextProps.language);
      }
    }
    if (nextProps.currency != this.state.currency) {
      this.setState({ currency: nextProps.currency, symbol: nextProps.symbol });
      isLoading = false;
    }
    // let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    // if(siteData){
    //   let top_position = siteData.notifications.filter((data)=>data.position=='top');
    //   let third_position = siteData.notifications.filter((data)=>data.position=='third_position');
    //   third_position = third_position[0] ? third_position[0] : third_position;
    //   this.setState({
    //     notifications: siteData.notifications,
    //     slider: siteData.slider,
    //     siteName: siteData.siteName,
    //     Optin: siteData.Optin,
    //     post_up: siteData.postup,
    //     PopupDealEndsubscrbe:siteData.PopupDealEndsubscrbe,
    //     top_position:top_position,
    //     third_position:third_position,
    //   });
    // }
    // this.setState({sending: nextProps.sending});
    if (
      nextProps.match.params &&
      nextProps.match.params.cityID &&
      nextProps.match.params.cityID.length > 0 &&
      nextProps.match.params.cityID != this.state.default_city
    ) {
      this.setState({
        default_city: nextProps.match.params.cityID,
      });
      this.handlePageChange(1);
      isLoading = false;
    }

    if (
      nextProps.siteStatus &&
      this.state.siteStatus !=
        nextProps.siteStatus /*&& this.state.default_city == '' */
    ) {
      this.handlePageChange(1);
      let siteData = nextProps.siteStatus;
      if (siteData) {
        let top_position = siteData.notifications.filter(
          (data) => data.position == "top"
        );
        let third_position = siteData.notifications.filter(
          (data) => data.position == "third_position"
        );
        third_position = third_position[0] ? third_position[0] : third_position;
        this.setState({
          siteStatus: nextProps.siteStatus,
          notifications: siteData.notifications,
          slider: siteData.slider,
          siteName: siteData.siteName,
          Optin: siteData.Optin,
          post_up: siteData.postup,
          PopupDealEndsubscrbe: siteData.PopupDealEndsubscrbe,
          top_position: top_position,
          third_position: third_position,
        });
      }
      isLoading = false;
    }

    if (
      nextProps.postupList &&
      this.state.postupList !== nextProps.postupList.data
    ) {
      this.setState({
        postupList: nextProps.postupList.data,
      });
      isLoading = "false";
    }

    if (nextProps.themeData && this.state.themeData != nextProps.themeData) {
      this.setState({ themeData: nextProps.themeData });
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          text_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
      if (lang == "fr") {
        this.setState({ NoRecord: nextProps.themeData.french_NoRecord });
      } else {
        this.setState({ NoRecord: nextProps.themeData.NoRecord });
      }
      this.setState({ fb_link: nextProps.themeData.fb_link });
      if (nextProps.themeData.menu_bar) {
        this.setState({
          menuBgStyles: {
            backgroundColor: nextProps.themeData.menu_bar.menu_bar_color,
          },
        });
      } else {
        this.setState({
          menuBgStyles: {
            backgroundColor: "",
          },
        });
      }
      isLoading = false;
    }

    if (nextProps.curDeal && nextProps.curDeal != this.state.curDealData) {
      this.setState({ curDealData: nextProps.curDeal });
      if (
        this.props.curDeal != nextProps.curDeal &&
        this.state.default_city !== ""
      ) {
        isLoading = true;
        this.setState({
          total: nextProps.curDeal.total ? nextProps.curDeal.total : 0,
          notFoundPopup: false,
        });
        this.setState({ curDeal: nextProps.curDeal.data });
        if (
          nextProps.curDeal &&
          nextProps.curDeal.data &&
          nextProps.curDeal.data.length > 0
        ) {
          let topDeals = nextProps.curDeal.data[0];
          topDeals.dealImages = nextProps.curDeal.data[0].top_deal_images;
          this.setState({
            topDeal: topDeals,
            notFoundPopup: false,
            load_more: false,
            sending: false,
          });
          this.setState({
            topDealHighlights: nextProps.curDeal.data[0].highlights
              ? JSON.parse(nextProps.curDeal.data[0].highlights)
              : "",
          });
          isLoading = false;
        } else {
          this.setState({
            curDeal: "",
            topDeal: "",
            topDealHighlights: "",
            removePopup: true,
            sending: false,
          });
          isLoading = false;
        }
      } else {
        if (isEmpty(nextProps.curDeal)) {
          this.setState({
            curDeal: "",
            topDeal: "",
            topDealHighlights: "",
            removePopup: true,
            sending: false,
          });
          isLoading = false;
        } else if (
          nextProps.curDeal &&
          this.props.curDeal == nextProps.curDeal &&
          nextProps.sending == true
        ) {
          isLoading = true;
          this.setState({
            total: nextProps.curDeal.total ? nextProps.curDeal.total : 0,
            notFoundPopup: false,
          });
          this.setState({ curDeal: nextProps.curDeal.data });
          if (
            nextProps.curDeal &&
            nextProps.curDeal.data &&
            nextProps.curDeal.data.length > 0
          ) {
            let topDeals = nextProps.curDeal.data[0];
            topDeals.dealImages = nextProps.curDeal.data[0].top_deal_images;
            this.setState({
              topDeal: topDeals,
              notFoundPopup: false,
              load_more: false,
              sending: false,
            });
            this.setState({
              topDealHighlights: nextProps.curDeal.data[0].highlights
                ? JSON.parse(nextProps.curDeal.data[0].highlights)
                : "",
            });
            isLoading = false;
          } else {
            this.setState({
              curDeal: "",
              topDeal: "",
              topDealHighlights: "",
              removePopup: true,
              sending: false,
            });
            isLoading = false;
          }
        }
      }
      isLoading = false;
    }

    if (this.state.pending_offers == "enable") {
      if (
        nextProps.upcomingDeal &&
        this.state.upcomingDeal !== nextProps.upcomingDeal
      ) {
        this.setState({
          upDeal: nextProps.upcomingDeal.data,
          utotal: nextProps.upcomingDeal.total
            ? nextProps.upcomingDeal.total
            : 0,
          upcomingDeal: nextProps.upcomingDeal,
          sending: false,
        });
        isLoading = false;
      }
      isLoading = false;
    }

    if (nextProps.error && this.state.error != nextProps.error) {
      this.setState({ error: nextProps.error });
      isLoading = false;
    }

    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
            this.setState({ upcominglink: siteData.upcominglink });
  
  }


}

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.state.curDeal === nextState.curDeal &&
      this.state.removePopup === false &&
      this.state.upDeal === nextState.upDeal
    ) {
      return false;
    } else {
      return true;
    }
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    });
  }

  submitSubscription = (e) => {
    e.preventDefault();
    if (this.state.email) {
      let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
      if (siteData && siteData.default_city) {
        const data = {
          city: [siteData.default_city],
          email: this.state.email,
          frequency: "",
          geo_subscriber: "yes",
        };
        this.props.subscribeUser(data);
      }
    } else {
      this.setState({ emailError: "red" });
    }
  };

  submitOptinForm = (e) => {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
      if (siteData && siteData.default_city) {
        const defaultCity = [siteData.default_city];
        const selectedCity = this.state.postupList.find(
          (k) => k.city == defaultCity
        );

        const data = {
          city:
            this.state.post_up === 1 && !isEmpty(selectedCity)
              ? [selectedCity.list_id]
              : [siteData.default_city],
          email: this.state.sub_email,
          zipcode: this.state.zipcode,
          dob: this.state.dob,
          frequency: "",
          geo_subscriber: "yes",
        };
        this.Clear();
        this.props.subscribeUser(data);
      }
    }
  };

  Clear() {
    this.setState({ sub_email: "", zipcode: "", dob: "" });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    if (!this.state.sub_email) {
      isError = true;
      this.setState({ sub_emailError: "red" });
    } else if (this.state.sub_email) {
      if (this.getValidationEmailState()) {
        isError = true;
        this.setState({ sub_emailError: "red" });
      }
    }

    if (!this.state.zipcode) {
      isError = true;
      this.setState({ zipcodeError: "red" });
    }

    if (!this.state.dob) {
      isError = true;
      this.setState({ dobError: "red" });
    }
    return isError;
  };

  getValidationEmailState() {
    if (this.state.sub_email) {
      const length = this.state.sub_email.length;
      if (length !== 0) {
        let emailpattern = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailpattern.test(this.state.sub_email)) {
          return "error";
        }
      }
    }
    return null;
  }

  handleSubscribe = (e) => {
    if (`this.state.${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangeDOBDate = (date) => {
    this.setState({ dob: date, dobError: "" });
  };
  render() {
    const {
      index,
      direction,
      notifications,
      width,
      top_position,
      third_position,
    } = this.state;
    const isMobile = width >= 600;
    let currentDeals, upDeal, totalDeal, utotalDeal, position, currentDeals2;
    // Timer
    let timerOption = "no";
    if (this.state.topDeal) {
      let dt1 = new Date(this.state.topDeal.today_date);
      let dt2 = new Date(this.state.topDeal.expiry_date);

      let diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60 * 60;

      if (
        diff <= parseInt(this.state.topDeal.timerStartInHour) &&
        this.state.topDeal.timerStartInHour > 0
      ) {
        timerOption = "yes";
      }

      if (
        this.state.topDeal.timerStartInHour === "" ||
        this.state.topDeal.timerStartInHour == 0
      ) {
        timerOption = "yes";
      }
    }
    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;
    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    if (this.state.pending_offers == "enable" && !isEmpty(this.state.upDeal)) {
      utotalDeal = this.state.upDeal.length;

      upDeal = this.state.upDeal.map((deal, index) => {
        let d1 = new Date(
          new Date().toLocaleString("en-US", {
            timeZone:
              this.state.siteStatus && deal.timezone
                ? deal.timezone
                : "America/New_York",
          })
        ); //new moment();

       let d2 = new moment(deal.deal_market_start_date);
        let duration = moment.duration(d2.diff(d1));
        let month = duration.get("month");
        let days = duration.get("days");
        let hours = duration.get("hours");
        let minutes = duration.get("minutes");
        let time_remaining =
          month > 0 ? (
            <div class="timer-div">
              <div class="time-block">
                <span class="time-data">{`${month}`}</span>
                <span class="time-txt">Mon</span>
              </div>
              <div class="time-block">
                <span class="time-data">{`${days}`}</span>
                <span class="time-txt">Days</span>
              </div>
              <div class="time-block">
                <span class="time-data">{`${hours}`}</span>
                <span class="time-txt">Hrs</span>
              </div>
              <div class="time-block">
                <span class="time-data">{`${minutes}`}</span>
                <span class="time-txt">Min</span>
              </div>
            </div>
          ) : days > 0 ? (
            <div class="timer-div">
              <div class="time-block">
                <span class="time-data">{`${days}`}</span>
                <span class="time-txt">Days</span>
              </div>
              <div class="time-block">
                <span class="time-data">{`${hours}`}</span>
                <span class="time-txt">Hrs</span>
              </div>
              <div class="time-block">
                <span class="time-data">{`${minutes}`}</span>
                <span class="time-txt">Min</span>
              </div>
            </div>
          ) : (
            <div class="timer-div">
              <div class="time-block">
                <span class="time-data">{`${hours}`}</span>
                <span class="time-txt">Hrs</span>
              </div>
              <div class="time-block">
                <span class="time-data">{`${minutes}`}</span>
                <span class="time-txt">Min</span>
              </div>
            </div>
          );

        return (
          <React.Fragment key={Math.random() + index}>
            <Col lg={4} md={4} sm={4} xs={12}>
              <div className="deal-container">
                <div className="deal-image">
                  <Image
                    src={
                      deal.dealImage && deal.dealImage.includes("http")
                        ? deal.dealImage
                        : deal.imageurl + deal.dealImage
                    }
                    alt={deal.img_alt_text}
                    title={deal.img_text}
                    description={deal.img_desc}
                    responsive
                  />
                </div>
                <h2 className="dealname">
                  {ReactHtmlParser(
                    deal.mainDealText != "" ? deal.mainDealText : deal.dealText
                  )}
                </h2>
                <div className="merchant">
                  {deal.useProdName == 0
                    ? deal.merchantName
                    : deal.prodName
                    ? deal.prodName
                    : deal.merchantName}
                </div>

                {deal.offerPrice > 0 ? (
                  <div className="prices">
                    {deal.offerPrice == deal.retailPrice ? (
                      <span className="percent" />
                    ) : (
                      <React.Fragment>
                        {deal.showDiscount == "1" &&
                          deal.proposal_type != 11 && (
                            <span
                              className="percent"
                              style={{ color: this.state.text_color }}
                            >
                              -
                              {Math.round(
                                100 - (deal.offerPrice / deal.retailPrice) * 100
                              )}
                              %
                            </span>
                          )}
                      </React.Fragment>
                    )}
                    {deal.showDiscount == "1" && deal.proposal_type != 11 && (
                      <Currency
                        amount={deal.retailPrice}
                        default_lang={this.state.default_lang}
                        className="price"
                        default_currency={this.state.currency}
                      />
                    )}
                    {deal.proposal_type == 11 && deal.lastAuctionAmount > 0 ? (
                      <Currency
                        amount={deal.lastAuctionAmount}
                        default_lang={this.state.default_lang}
                        className="current"
                        default_currency={this.state.currency}
                      />
                    ) : (
                      <Currency
                        amount={deal.offerPrice}
                        default_lang={this.state.default_lang}
                        className="current"
                        default_currency={this.state.currency}
                      />
                    )}
                  </div>
                ) : (
                  <div className="prices">
                    {this.state.topDeal.proposal_type == 7 ? (
                      <span
                        className="percent"
                        style={{ color: this.state.text_color }}
                      >
                        {deal.percentageOff}% OFF
                      </span>
                    ) : (
                      <span
                        className="percent"
                        style={{ color: this.state.text_color }}
                      >
                        {this.state.topDeal.proposal_type == 6
                          ? languageConfig[this.state.default_lang]
                              .proposal_coupon
                          : languageConfig[this.state.default_lang].free_text}
                      </span>
                    )}
                  </div>
                )}

                <div className="short-disc">
                  {!isEmpty(deal.writeUp)
                    ? ReactHtmlParser(
                        deal.writeUp.substring(0, 180).replace(/<[^>]+>/g, "")
                      )
                    : ""}
                </div>

                <div className="text-center timer">
                  <p>
                    <b>
                      {languageConfig[this.state.default_lang].time_remaining}
                    </b>
                  </p>
                  <div className="sale-timer">
                    <div className="time-icon">
                      <i className="glyphicon glyphicon-time" />
                    </div>{" "}
                    {time_remaining}
                  </div>
                </div>

                <div className="deal-footer">
                {this.state.upcominglink =="enable" ?
                (  <Link
                            className="btn btn-deal"
                            data-id={deal.dealID}
                            onMouseEnter={this.hoverOn}
                            onMouseLeave={this.hoverOff}
                            style={{
                              backgroundColor:
                                this.state.hover &&
                                this.state.hoverID == deal.dealID
                                  ? this.state.mouseover_color
                                  : this.state.button_color,
                              display: "block",
                            }}
                            key={Math.random()}
                            to={
                              deal.offer_url
                                ? `/deals-detail/${deal.offer_url}/${this.state.default_city}`
                                : `/deals-detail/${
                                    deal.dealID
                                  }-${deal.merchantName
                                    .toLowerCase()
                                    .trim()
                                    .split(/\s+/)
                                    .join("-")}/${this.state.default_city}`
                            }
                          >

                            {languageConfig[this.state.default_lang].view}
                          </Link> ) :(
                  <a
                    className="btn btn-deal"
                    style={{
                      backgroundColor:
                        this.state.hover && this.state.hoverID == deal.dealID
                          ? this.state.mouseover_color
                          : this.state.button_color,
                    }}
                    data-id={deal.dealID}
                    onMouseEnter={this.hoverOn}
                    onMouseLeave={this.hoverOff}
                  >
                    {languageConfig[this.state.default_lang].comming_soon}
                  </a>
                  )}
                </div>
              </div>
            </Col>
          </React.Fragment>
        );
      });
    }

    if (!isEmpty(this.state.curDeal)) {
      totalDeal = this.state.curDeal.length;
      let checkIndex = this.state.featured_offer == 1 ? 0 : -1;
      if (this.state.slider == "1") {
        checkIndex = this.state.featured_offer == 1 ? 2 : -1;
      }
      let third_position = this.state.notifications.filter((data, index) => {
        return data.position == "third_position";
      });

      let limitIndex = checkIndex;
      if (
        this.state.notifications &&
        this.state.notifications != "" &&
        !isEmpty(third_position)
      ) {
        limitIndex = limitIndex + 2;
      }
      if (this.state.Optin == 1) {
        limitIndex = limitIndex + 2;
      }
      if (this.state.fb_link != "" && this.state.fb_link != null) {
        limitIndex = limitIndex + 2;
      }
      if (limitIndex != checkIndex) {
        currentDeals = this.state.curDeal.map((deal, index) => {
          let newDealPrice = "",
            newRetailPrice = "";
          newDealPrice = deal.offerPrice;
          newRetailPrice = deal.retailPrice;

          if (index > checkIndex && index <= limitIndex) {
            return (
              <React.Fragment key={Math.random() + index}>
                <Col lg={6} md={6} sm={6} xs={12} key={Math.random() + index}>
                  <div className="deal-container shadow">
                    <div className="deal-image">
                      {deal.proposal_type == 11 ? (
                        <Link
                          key={Math.random()}
                          to={
                            deal.offer_url
                              ? `/auction-detail/${deal.offer_url}/${this.state.default_city}`
                              : `/auction-detail/${
                                  deal.dealID
                                }-${deal.merchantName
                                  .toLowerCase()
                                  .trim()
                                  .split(/\s+/)
                                  .join("-")}/${this.state.default_city}`
                          }
                        >
                          <Image
                            src={
                              deal.dealImage.includes("http")
                                ? deal.dealImage
                                  ? deal.dealImage
                                  : noImg
                                : deal.dealImage
                                ? deal.imageurl + deal.dealImage
                                : noImg
                            }
                            alt={deal.img_alt_text}
                            title={deal.img_text}
                            description={deal.img_desc}
                            responsive
                          />
                        </Link>
                      ) : (
                        <Link
                          key={Math.random()}
                          to={
                            deal.offer_url
                              ? `/deals-detail/${deal.offer_url}/${this.state.default_city}`
                              : `/deals-detail/${
                                  deal.dealID
                                }-${deal.merchantName
                                  .toLowerCase()
                                  .trim()
                                  .split(/\s+/)
                                  .join("-")}/${this.state.default_city}`
                          }
                        >
                          <Image
                            src={
                              deal.dealImage.includes("http")
                                ? deal.dealImage
                                  ? deal.dealImage
                                  : noImg
                                : deal.dealImage
                                ? deal.imageurl + deal.dealImage
                                : noImg
                            }
                            alt={deal.img_alt_text}
                            title={deal.img_text}
                            description={deal.img_desc}
                            responsive
                          />
                        </Link>
                      )}
                    </div>
                    <h2 className="dealname">
                      {ReactHtmlParser(
                        deal.mainDealText != ""
                          ? deal.mainDealText
                          : deal.dealText
                      )}
                    </h2>
                    <div className="merchant">
                      {deal.useProdName == 0
                        ? deal.merchantName
                        : deal.prodName
                        ? deal.prodName
                        : deal.merchantName}
                    </div>

                    {newDealPrice > 0 ? (
                      <div className="prices">
                        {newDealPrice == newRetailPrice ? (
                          <span className="percent" />
                        ) : (
                          <React.Fragment>
                            {deal.showDiscount == "1" &&
                              deal.proposal_type != 11 && (
                                <span
                                  className="percent"
                                  style={{ color: this.state.text_color }}
                                >
                                  -
                                  {Math.round(
                                    100 - (newDealPrice / newRetailPrice) * 100
                                  )}
                                  %
                                </span>
                              )}
                          </React.Fragment>
                        )}
                        {deal.showDiscount == "1" &&
                          deal.proposal_type != 11 && (
                            <Currency
                              amount={newRetailPrice}
                              default_lang={this.state.default_lang}
                              className="price"
                              default_currency={this.state.currency}
                            />
                          )}
                        {deal.proposal_type == 11 &&
                        deal.lastAuctionAmount > 0 ? (
                          <Currency
                            amount={deal.lastAuctionAmount}
                            default_lang={this.state.default_lang}
                            className="current"
                            default_currency={this.state.currency}
                          />
                        ) : (
                          <Currency
                            amount={newDealPrice}
                            default_lang={this.state.default_lang}
                            className="current"
                            default_currency={this.state.currency}
                          />
                        )}
                      </div>
                    ) : (
                      <div className="prices">
                        {deal.proposal_type == 7 ? (
                          <span
                            className="percent"
                            style={{ color: this.state.text_color }}
                          >
                            {deal.percentageOff}% OFF
                          </span>
                        ) : (
                          <span
                            className="percent"
                            style={{ color: this.state.text_color }}
                          >
                            {deal.proposal_type == 6
                              ? languageConfig[this.state.default_lang]
                                  .proposal_coupon
                              : languageConfig[this.state.default_lang]
                                  .free_text}
                          </span>
                        )}
                      </div>
                    )}

                    <div className="short-disc">
                      {!isEmpty(deal.writeUp)
                        ? ReactHtmlParser(
                            deal.writeUp
                              .substring(0, 180)
                              .replace(/<[^>]+>/g, "")
                          )
                        : ""}
                    </div>
                    <div className="deal-footer">
                      {isIE == false && isEdge == false && isMobile ? (
                        deal.proposal_type == 11 ? (
                          <Link
                            className="btn btn-deal"
                            data-id={deal.dealID}
                            onMouseEnter={this.hoverOn}
                            onMouseLeave={this.hoverOff}
                            style={{
                              backgroundColor:
                                this.state.hover &&
                                this.state.hoverID == deal.dealID
                                  ? this.state.mouseover_color
                                  : this.state.button_color,
                              display: "block",
                            }}
                            key={Math.random()}
                            to={
                              deal.offer_url
                                ? `/auction-detail/${deal.offer_url}/${this.state.default_city}`
                                : `/auction-detail/${
                                    deal.dealID
                                  }-${deal.merchantName
                                    .toLowerCase()
                                    .trim()
                                    .split(/\s+/)
                                    .join("-")}/${this.state.default_city}`
                            }
                          >
                            {deal.sold_out == "true"
                              ? languageConfig[this.state.default_lang]
                                  .auction_ended
                              : languageConfig[this.state.default_lang]
                                  .auction_view}
                          </Link>
                        ) : (
                          <Link
                            className="btn btn-deal"
                            data-id={deal.dealID}
                            onMouseEnter={this.hoverOn}
                            onMouseLeave={this.hoverOff}
                            style={{
                              backgroundColor:
                                this.state.hover &&
                                this.state.hoverID == deal.dealID
                                  ? this.state.mouseover_color
                                  : this.state.button_color,
                              display: "block",
                            }}
                            key={Math.random()}
                            to={
                              deal.offer_url
                                ? `/deals-detail/${deal.offer_url}/${this.state.default_city}`
                                : `/deals-detail/${
                                    deal.dealID
                                  }-${deal.merchantName
                                    .toLowerCase()
                                    .trim()
                                    .split(/\s+/)
                                    .join("-")}/${this.state.default_city}`
                            }
                          >
                            {deal.sold_out == "true"
                              ? languageConfig[this.state.default_lang].sold_out
                              : languageConfig[this.state.default_lang].view}
                          </Link>
                        )
                      ) : deal.proposal_type == 11 ? (
                        <Link
                          className="btn btn-deal"
                          data-id={deal.dealID}
                          style={{
                            backgroundColor:
                              this.state.hover &&
                              this.state.hoverID == deal.dealID
                                ? this.state.mouseover_color
                                : this.state.button_color,
                            display: "block",
                          }}
                          key={Math.random()}
                          to={
                            deal.offer_url
                              ? `/auction-detail/${deal.offer_url}/${this.state.default_city}`
                              : `/auction-detail/${
                                  deal.dealID
                                }-${deal.merchantName
                                  .toLowerCase()
                                  .trim()
                                  .split(/\s+/)
                                  .join("-")}/${this.state.default_city}`
                          }
                        >
                          {deal.sold_out == "true"
                            ? languageConfig[this.state.default_lang]
                                .auction_ended
                            : languageConfig[this.state.default_lang]
                                .auction_view}
                        </Link>
                      ) : (
                        <Link
                          className="btn btn-deal"
                          data-id={deal.dealID}
                          style={{
                            backgroundColor:
                              this.state.hover &&
                              this.state.hoverID == deal.dealID
                                ? this.state.mouseover_color
                                : this.state.button_color,
                            display: "block",
                          }}
                          key={Math.random()}
                          to={
                            deal.offer_url
                              ? `/deals-detail/${deal.offer_url}/${this.state.default_city}`
                              : `/deals-detail/${
                                  deal.dealID
                                }-${deal.merchantName
                                  .toLowerCase()
                                  .trim()
                                  .split(/\s+/)
                                  .join("-")}/${this.state.default_city}`
                          }
                        >
                          {deal.sold_out == "true"
                            ? languageConfig[this.state.default_lang].sold_out
                            : languageConfig[this.state.default_lang].view}
                        </Link>
                      )}
                    </div>
                  </div>
                </Col>
              </React.Fragment>
            );
          }
        });
      }

      currentDeals2 = this.state.curDeal.map((deal, index) => {
        let newDealPrice = "",
          newRetailPrice = "";
        newDealPrice = deal.offerPrice;
        newRetailPrice = deal.retailPrice;
        if (index > limitIndex) {
          return (
            <React.Fragment key={Math.random() + index}>
              <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
                <div className="deal-container shadow">
                  <div className="deal-image">
                    {deal.proposal_type == 11 ? (
                      <Link
                        key={Math.random()}
                        to={
                          deal.offer_url
                            ? `/auction-detail/${deal.offer_url}/${this.state.default_city}`
                            : `/auction-detail/${
                                deal.dealID
                              }-${deal.merchantName
                                .toLowerCase()
                                .trim()
                                .split(/\s+/)
                                .join("-")}/${this.state.default_city}`
                        }
                      >
                        <Image
                          src={
                            deal.dealImage.includes("http")
                              ? deal.dealImage
                                ? deal.dealImage
                                : noImg
                              : deal.dealImage
                              ? deal.imageurl + deal.dealImage
                              : noImg
                          }
                          alt={deal.img_alt_text}
                          title={deal.img_text}
                          description={deal.img_desc}
                          responsive
                        />
                      </Link>
                    ) : (
                      <Link
                        key={Math.random()}
                        to={
                          deal.offer_url
                            ? `/deals-detail/${deal.offer_url}/${this.state.default_city}`
                            : `/deals-detail/${deal.dealID}-${deal.merchantName
                                .toLowerCase()
                                .trim()
                                .split(/\s+/)
                                .join("-")}/${this.state.default_city}`
                        }
                      >
                        <Image
                          src={
                            deal.dealImage.includes("http")
                              ? deal.dealImage
                                ? deal.dealImage
                                : noImg
                              : deal.dealImage
                              ? deal.imageurl + deal.dealImage
                              : noImg
                          }
                          alt={deal.img_alt_text}
                          title={deal.img_text}
                          description={deal.img_desc}
                          responsive
                        />
                      </Link>
                    )}
                  </div>
                  <h2 className="dealname">
                    {ReactHtmlParser(
                      deal.mainDealText != ""
                        ? deal.mainDealText
                        : deal.dealText
                    )}
                  </h2>
                  <div className="merchant">
                    {deal.useProdName == 0
                      ? deal.merchantName
                      : deal.prodName
                      ? deal.prodName
                      : deal.merchantName}
                  </div>

                  {newDealPrice > 0 ? (
                    <div className="prices">
                      {newDealPrice == newRetailPrice ? (
                        <span className="percent" />
                      ) : (
                        <React.Fragment>
                          {deal.showDiscount == "1" &&
                            deal.proposal_type != 11 && (
                              <span
                                className="percent"
                                style={{ color: this.state.text_color }}
                              >
                                -
                                {Math.round(
                                  100 - (newDealPrice / newRetailPrice) * 100
                                )}
                                %
                              </span>
                            )}
                        </React.Fragment>
                      )}
                      {deal.showDiscount == "1" && deal.proposal_type != 11 && (
                        <Currency
                          amount={newRetailPrice}
                          default_lang={this.state.default_lang}
                          className="price"
                          default_currency={this.state.currency}
                        />
                      )}
                      {deal.proposal_type == 11 &&
                      deal.lastAuctionAmount > 0 ? (
                        <Currency
                          amount={deal.lastAuctionAmount}
                          default_lang={this.state.default_lang}
                          className="current"
                          default_currency={this.state.currency}
                        />
                      ) : (
                        <Currency
                          amount={newDealPrice}
                          default_lang={this.state.default_lang}
                          className="current"
                          default_currency={this.state.currency}
                        />
                      )}
                    </div>
                  ) : (
                    <div className="prices">
                      {deal.proposal_type == 7 ? (
                        <span
                          className="percent"
                          style={{ color: this.state.text_color }}
                        >
                          {deal.percentageOff}% OFF
                        </span>
                      ) : (
                        <span
                          className="percent"
                          style={{ color: this.state.text_color }}
                        >
                          {deal.proposal_type == 6
                            ? languageConfig[this.state.default_lang]
                                .proposal_coupon
                            : languageConfig[this.state.default_lang].free_text}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="short-disc">
                    {!isEmpty(deal.writeUp)
                      ? ReactHtmlParser(
                          deal.writeUp.substring(0, 180).replace(/<[^>]+>/g, "")
                        )
                      : ""}
                  </div>
                  <div className="deal-footer">
                    {isIE == false && isEdge == false && isMobile ? (
                      deal.proposal_type == 11 ? (
                        <Link
                          className="btn btn-deal"
                          data-id={deal.dealID}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                          style={{
                            backgroundColor:
                              this.state.hover &&
                              this.state.hoverID == deal.dealID
                                ? this.state.mouseover_color
                                : this.state.button_color,
                            display: "block",
                          }}
                          key={Math.random()}
                          to={
                            deal.offer_url
                              ? `/auction-detail/${deal.offer_url}/${this.state.default_city}`
                              : `/auction-detail/${
                                  deal.dealID
                                }-${deal.merchantName
                                  .toLowerCase()
                                  .trim()
                                  .split(/\s+/)
                                  .join("-")}/${this.state.default_city}`
                          }
                        >
                          {deal.sold_out == "true"
                            ? languageConfig[this.state.default_lang]
                                .auction_ended
                            : languageConfig[this.state.default_lang]
                                .auction_view}
                        </Link>
                      ) : (
                        <Link
                          className="btn btn-deal"
                          data-id={deal.dealID}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                          style={{
                            backgroundColor:
                              this.state.hover &&
                              this.state.hoverID == deal.dealID
                                ? this.state.mouseover_color
                                : this.state.button_color,
                            display: "block",
                          }}
                          key={Math.random()}
                          to={
                            deal.offer_url
                              ? `/deals-detail/${deal.offer_url}/${this.state.default_city}`
                              : `/deals-detail/${
                                  deal.dealID
                                }-${deal.merchantName
                                  .toLowerCase()
                                  .trim()
                                  .split(/\s+/)
                                  .join("-")}/${this.state.default_city}`
                          }
                        >
                          {deal.sold_out == "true"
                            ? languageConfig[this.state.default_lang].sold_out
                            : languageConfig[this.state.default_lang].view}
                        </Link>
                      )
                    ) : deal.proposal_type == 11 ? (
                      <Link
                        className="btn btn-deal"
                        data-id={deal.dealID}
                        style={{
                          backgroundColor:
                            this.state.hover &&
                            this.state.hoverID == deal.dealID
                              ? this.state.mouseover_color
                              : this.state.button_color,
                          display: "block",
                        }}
                        key={Math.random()}
                        to={
                          deal.offer_url
                            ? `/auction-detail/${deal.offer_url}/${this.state.default_city}`
                            : `/auction-detail/${
                                deal.dealID
                              }-${deal.merchantName
                                .toLowerCase()
                                .trim()
                                .split(/\s+/)
                                .join("-")}/${this.state.default_city}`
                        }
                      >
                        {deal.sold_out == "true"
                          ? languageConfig[this.state.default_lang]
                              .auction_ended
                          : languageConfig[this.state.default_lang]
                              .auction_view}
                      </Link>
                    ) : (
                      <Link
                        className="btn btn-deal"
                        data-id={deal.dealID}
                        style={{
                          backgroundColor:
                            this.state.hover &&
                            this.state.hoverID == deal.dealID
                              ? this.state.mouseover_color
                              : this.state.button_color,
                          display: "block",
                        }}
                        key={Math.random()}
                        to={
                          deal.offer_url
                            ? `/deals-detail/${deal.offer_url}/${this.state.default_city}`
                            : `/deals-detail/${deal.dealID}-${deal.merchantName
                                .toLowerCase()
                                .trim()
                                .split(/\s+/)
                                .join("-")}/${this.state.default_city}`
                        }
                      >
                        {deal.sold_out == "true"
                          ? languageConfig[this.state.default_lang].sold_out
                          : languageConfig[this.state.default_lang].view}
                      </Link>
                    )}
                  </div>
                </div>
              </Col>
            </React.Fragment>
          );
        }
      });
    }

    // let multiprice = '', retailPrice = '', saving_percent = '', saving_amount='';
    // if(!isEmpty(this.state.topDeal) && !isEmpty(this.state.topDeal.child_deals)) {
    //     this.state.topDeal.child_deals.map((deal, index) => {
    //     if(now.isAfter(deal.startDateTime) && now.isBefore(deal.expiryDateTime) && multiprice == ''){
    //       multiprice = deal.offerPrice;
    //       retailPrice = deal.retailPrice;
    //       saving_percent = deal.saving_percent;
    //       saving_amount= deal.saving_amount;
    //     }
    //   })
    // }
    return (
      <div>
        {this.state.sending == true || isLoading == true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {!isEmpty(this.state.topDeal) && isLoading != true ? (
          <React.Fragment>
            <div className="container">
              {this.state.slider == "1" && this.state.featured_offer == 1 ? (
                <div className="bg-white slider-container shadow">
                  <Carousel id="main-slider">
                    {!isEmpty(this.state.curDeal) &&
                    this.state.featured_offer == 1
                      ? this.state.curDeal.map((data, index) => {
                          if (index <= 2) {
                            return (
                              <Carousel.Item>
                                <Row className="deal-banner">
                                  <Col lg={8} md={8} sm={6} xs={12}>
                                    {data.proposal_type == 11 ? (
                                      <a
                                        onClick={() =>
                                          data.offer_url
                                            ? this.context.router.history.push(
                                                `/auction-detail/${data.offer_url}/${this.state.default_city}`
                                              )
                                            : this.context.router.history.push(
                                                `/auction-detail/${
                                                  data.dealID
                                                }-${data.merchantName
                                                  .toLowerCase()
                                                  .trim()
                                                  .split(/\s+/)
                                                  .join("-")}/${
                                                  this.state.default_city
                                                }`
                                              )
                                        }
                                      >
                                        {!isEmpty(data.top_deal_images) ? (
                                          <div
                                            className="dealSingleimage"
                                            style={{
                                              backgroundImage: `url(${
                                                data.top_deal_images[0].slider_image.includes(
                                                  "http://product-images.imshopping.com"
                                                )
                                                  ? data.top_deal_images[0].slider_image.replace(
                                                      "https://d266oi3blg1w2v.cloudfront.net/",
                                                      ""
                                                    )
                                                  : data.top_deal_images[0]
                                                      .slider_image
                                              })`,
                                              backgroundPosition: "center",
                                              backgroundSize: "contain",
                                              backgroundColor: "#fff",
                                            }}
                                          ></div>
                                        ) : (
                                          <div className="dealSingleimage">
                                            <Image responsive src={noImg} />
                                          </div>
                                        )}
                                      </a>
                                    ) : (
                                      <a
                                        onClick={() =>
                                          data.offer_url
                                            ? this.context.router.history.push(
                                                `/deals-detail/${data.offer_url}/${this.state.default_city}`
                                              )
                                            : this.context.router.history.push(
                                                `/deals-detail/${
                                                  data.dealID
                                                }-${data.merchantName
                                                  .toLowerCase()
                                                  .trim()
                                                  .split(/\s+/)
                                                  .join("-")}/${
                                                  this.state.default_city
                                                }`
                                              )
                                        }
                                      >
                                        {!isEmpty(data.top_deal_images) ? (
                                          <div
                                            className="dealSingleimage"
                                            style={{
                                              backgroundImage: `url(${
                                                data.top_deal_images[0].slider_image.includes(
                                                  "http://product-images.imshopping.com"
                                                )
                                                  ? data.top_deal_images[0].slider_image.replace(
                                                      "https://d266oi3blg1w2v.cloudfront.net/",
                                                      ""
                                                    )
                                                  : data.top_deal_images[0]
                                                      .slider_image
                                              })`,
                                              backgroundPosition: "center",
                                              backgroundSize: "contain",
                                              backgroundColor: "#fff",
                                            }}
                                          ></div>
                                        ) : (
                                          <div className="dealSingleimage">
                                            <Image responsive src={noImg} />
                                          </div>
                                        )}
                                      </a>
                                    )}
                                  </Col>
                                  <Col lg={4} md={4} sm={6} xs={12}>
                                    <div className="bannerDeal text-center clearfix">
                                      <h2 className="dealname text-center">
                                        {ReactHtmlParser(data.mainDealText)}
                                      </h2>
                                      <div className="merchant merchantname">
                                        {data.useProdName &&
                                        data.useProdName == 0
                                          ? data.merchantName
                                          : data.prodName
                                          ? data.prodName
                                          : data.merchantName}
                                        <br />
                                        <div className="fonthighlights text-center">
                                          <ul>
                                            {data.highlights &&
                                              data.highlights.first && (
                                                <li key={Math.random()}>
                                                  <i
                                                    className="glyphicon glyphicon-check"
                                                    style={{
                                                      color:
                                                        this.state.button_color,
                                                    }}
                                                  ></i>{" "}
                                                  {data.highlights.first}
                                                </li>
                                              )}
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="deals-price">
                                        {!isEmpty(data.child_deals) ? (
                                          multiprice == "0.00" ||
                                          data.offerPrice == "0.00" ? (
                                            <span
                                              className="price"
                                              style={{
                                                display:
                                                  data.proposal_type == 7
                                                    ? "none"
                                                    : "block",
                                              }}
                                            >
                                              {data.proposal_type == 6
                                                ? languageConfig[
                                                    this.state.default_lang
                                                  ].proposal_coupon
                                                : languageConfig[
                                                    this.state.default_lang
                                                  ].free_text}
                                            </span>
                                          ) : data.proposal_type == 11 &&
                                            data.lastAuctionAmount > 0 ? (
                                            <Currency
                                              amount={data.lastAuctionAmount}
                                              default_lang={
                                                this.state.default_lang
                                              }
                                              className="price"
                                              default_currency={
                                                this.state.currency
                                              }
                                            />
                                          ) : data.proposal_type == 11 &&
                                            data.lastAuctionAmount == "" &&
                                            data.lastAuctionAmount == null ? (
                                            <Currency
                                              amount={data.offerPrice}
                                              default_lang={
                                                this.state.default_lang
                                              }
                                              className="price"
                                              default_currency={
                                                this.state.currency
                                              }
                                            />
                                          ) : data.proposal_type != 7 ? (
                                            <Currency
                                              amount={
                                                multiprice != ""
                                                  ? multiprice
                                                  : data.offerPrice
                                              }
                                              default_lang={
                                                this.state.default_lang
                                              }
                                              className="price"
                                              default_currency={
                                                this.state.currency
                                              }
                                            />
                                          ) : null
                                        ) : data.offerPrice == "0.00" ? (
                                          <span
                                            className="price"
                                            style={{
                                              display:
                                                data.proposal_type == 7
                                                  ? "none"
                                                  : "block",
                                            }}
                                          >
                                            {data.proposal_type == 6
                                              ? languageConfig[
                                                  this.state.default_lang
                                                ].proposal_coupon
                                              : languageConfig[
                                                  this.state.default_lang
                                                ].free_text}
                                          </span>
                                        ) : data.proposal_type == 11 &&
                                          data.lastAuctionAmount > 0 ? (
                                          <Currency
                                            amount={data.lastAuctionAmount}
                                            default_lang={
                                              this.state.default_lang
                                            }
                                            className="price"
                                            default_currency={
                                              this.state.currency
                                            }
                                          />
                                        ) : data.proposal_type == 11 &&
                                          data.lastAuctionAmount == "" &&
                                          data.lastAuctionAmount == null ? (
                                          <Currency
                                            amount={data.offerPrice}
                                            default_lang={
                                              this.state.default_lang
                                            }
                                            className="price"
                                            default_currency={
                                              this.state.currency
                                            }
                                          />
                                        ) : data.proposal_type != 7 ? (
                                          <Currency
                                            amount={data.offerPrice}
                                            default_lang={
                                              this.state.default_lang
                                            }
                                            className="price"
                                            default_currency={
                                              this.state.currency
                                            }
                                          />
                                        ) : null}
                                        <h5 className="merchant text-center">
                                          {data.shortTitle}
                                        </h5>
                                        {isIE == false &&
                                        isEdge == false &&
                                        isMobile ? (
                                          data.proposal_type == 11 ? (
                                            <a
                                              className="view-button btn btn-deal"
                                              style={{
                                                backgroundColor:
                                                  this.state.hover &&
                                                  this.state.hoverID ==
                                                    data.dealID
                                                    ? this.state.mouseover_color
                                                    : this.state.button_color,
                                              }}
                                              data-id={data.dealID}
                                              onMouseEnter={this.hoverOn}
                                              onMouseLeave={this.hoverOff}
                                              onClick={() =>
                                                data.offer_url
                                                  ? this.context.router.history.push(
                                                      `/auction-detail/${data.offer_url}/${this.state.default_city}`
                                                    )
                                                  : this.context.router.history.push(
                                                      `/auction-detail/${
                                                        data.dealID
                                                      }-${data.merchantName
                                                        .toLowerCase()
                                                        .trim()
                                                        .split(/\s+/)
                                                        .join("-")}/${
                                                        this.state.default_city
                                                      }`
                                                    )
                                              }
                                            >
                                              {data.sold_out == "true"
                                                ? languageConfig[
                                                    this.state.default_lang
                                                  ].auction_ended
                                                : languageConfig[
                                                    this.state.default_lang
                                                  ].auction_view}
                                            </a>
                                          ) : (
                                            <a
                                              className="view-button btn btn-deal"
                                              style={{
                                                backgroundColor:
                                                  this.state.hover &&
                                                  this.state.hoverID ==
                                                    data.dealID
                                                    ? this.state.mouseover_color
                                                    : this.state.button_color,
                                              }}
                                              data-id={data.dealID}
                                              onMouseEnter={this.hoverOn}
                                              onMouseLeave={this.hoverOff}
                                              onClick={() =>
                                                data.offer_url
                                                  ? this.context.router.history.push(
                                                      `/deals-detail/${data.offer_url}/${this.state.default_city}`
                                                    )
                                                  : this.context.router.history.push(
                                                      `/deals-detail/${
                                                        data.dealID
                                                      }-${data.merchantName
                                                        .toLowerCase()
                                                        .trim()
                                                        .split(/\s+/)
                                                        .join("-")}/${
                                                        this.state.default_city
                                                      }`
                                                    )
                                              }
                                            >
                                              {data.sold_out == "true"
                                                ? languageConfig[
                                                    this.state.default_lang
                                                  ].sold_out
                                                : languageConfig[
                                                    this.state.default_lang
                                                  ].view}
                                            </a>
                                          )
                                        ) : data.proposal_type == 11 ? (
                                          <a
                                            className="view-button btn btn-deal"
                                            style={{
                                              backgroundColor:
                                                this.state.hover &&
                                                this.state.hoverID ==
                                                  data.dealID
                                                  ? this.state.mouseover_color
                                                  : this.state.button_color,
                                            }}
                                            data-id={data.dealID}
                                            onClick={() =>
                                              data.offer_url
                                                ? this.context.router.history.push(
                                                    `/auction-detail/${data.offer_url}/${this.state.default_city}`
                                                  )
                                                : this.context.router.history.push(
                                                    `/auction-detail/${
                                                      data.dealID
                                                    }-${data.merchantName
                                                      .toLowerCase()
                                                      .trim()
                                                      .split(/\s+/)
                                                      .join("-")}/${
                                                      this.state.default_city
                                                    }`
                                                  )
                                            }
                                          >
                                            {data.sold_out == "true"
                                              ? languageConfig[
                                                  this.state.default_lang
                                                ].auction_ended
                                              : languageConfig[
                                                  this.state.default_lang
                                                ].auction_view}
                                          </a>
                                        ) : (
                                          <a
                                            className="view-button btn btn-deal"
                                            style={{
                                              backgroundColor:
                                                this.state.hover &&
                                                this.state.hoverID ==
                                                  data.dealID
                                                  ? this.state.mouseover_color
                                                  : this.state.button_color,
                                            }}
                                            data-id={data.dealID}
                                            onClick={() =>
                                              data.offer_url
                                                ? this.context.router.history.push(
                                                    `/deals-detail/${data.offer_url}/${this.state.default_city}`
                                                  )
                                                : this.context.router.history.push(
                                                    `/deals-detail/${
                                                      data.dealID
                                                    }-${data.merchantName
                                                      .toLowerCase()
                                                      .trim()
                                                      .split(/\s+/)
                                                      .join("-")}/${
                                                      this.state.default_city
                                                    }`
                                                  )
                                            }
                                          >
                                            {data.sold_out == "true"
                                              ? languageConfig[
                                                  this.state.default_lang
                                                ].sold_out
                                              : languageConfig[
                                                  this.state.default_lang
                                                ].view}
                                          </a>
                                        )}
                                      </div>

                                      {!isEmpty(data.child_deals) ? (
                                        data.proposal_type != 11 ? (
                                          <React.Fragment>
                                            {data.showDiscount == "1" &&
                                              data.proposal_type == 7 && (
                                                <div className="text-center">
                                                  <div className="valueInfo shadow">
                                                    <div className="save">
                                                      <p className="value">
                                                        {data.percentageOff}%
                                                        off
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            {data.showDiscount == "1" &&
                                              data.proposal_type != 7 && (
                                                <div className="text-center">
                                                  <div className="valueInfo shadow">
                                                    <div className="value">
                                                      <p className="value">
                                                        <Currency
                                                          amount={
                                                            retailPrice != ""
                                                              ? retailPrice
                                                              : data.retailPrice
                                                          }
                                                          default_lang={
                                                            this.state
                                                              .default_lang
                                                          }
                                                          className=""
                                                          default_currency={
                                                            this.state.currency
                                                          }
                                                        />
                                                      </p>
                                                      <p className="text">
                                                        {
                                                          languageConfig[
                                                            this.state
                                                              .default_lang
                                                          ].value
                                                        }
                                                      </p>
                                                    </div>

                                                    <div className="discount">
                                                      <p className="value">
                                                        {saving_percent != ""
                                                          ? saving_percent
                                                          : this.state.topDeal
                                                              .saving_percent}
                                                        %
                                                      </p>
                                                      <p className="text">
                                                        {
                                                          languageConfig[
                                                            this.state
                                                              .default_lang
                                                          ].discount
                                                        }
                                                      </p>
                                                    </div>

                                                    <div className="save">
                                                      <p className="value">
                                                        <Currency
                                                          amount={
                                                            saving_amount != ""
                                                              ? saving_amount
                                                              : data.saving_amount
                                                          }
                                                          default_lang={
                                                            this.state
                                                              .default_lang
                                                          }
                                                          className=""
                                                          default_currency={
                                                            this.state.currency
                                                          }
                                                        />
                                                      </p>
                                                      <p className="text">
                                                        {
                                                          languageConfig[
                                                            this.state
                                                              .default_lang
                                                          ].savings
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                          </React.Fragment>
                                        ) : (
                                          ""
                                        )
                                      ) : data.proposal_type != 11 ? (
                                        <React.Fragment>
                                          {data.showDiscount == "1" &&
                                            data.proposal_type == 7 && (
                                              <div className="text-center">
                                                <div className="valueInfo shadow">
                                                  <div className="save">
                                                    <p className="value">
                                                      {data.percentageOff}% off
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          {data.showDiscount == "1" &&
                                            data.proposal_type != 7 && (
                                              <div className="text-center">
                                                <div className="valueInfo shadow">
                                                  <div className="value">
                                                    <p className="value">
                                                      <Currency
                                                        amount={
                                                          data.retailPrice
                                                        }
                                                        default_lang={
                                                          this.state
                                                            .default_lang
                                                        }
                                                        className=""
                                                        default_currency={
                                                          this.state.currency
                                                        }
                                                      />
                                                    </p>
                                                    <p className="text">
                                                      {
                                                        languageConfig[
                                                          this.state
                                                            .default_lang
                                                        ].value
                                                      }
                                                    </p>
                                                  </div>

                                                  <div className="discount">
                                                    <p className="value">
                                                      {data.saving_percent}%
                                                    </p>
                                                    <p className="text">
                                                      {
                                                        languageConfig[
                                                          this.state
                                                            .default_lang
                                                        ].discount
                                                      }
                                                    </p>
                                                  </div>

                                                  <div className="save">
                                                    <p className="value">
                                                      <Currency
                                                        amount={
                                                          data.saving_amount
                                                        }
                                                        default_lang={
                                                          this.state
                                                            .default_lang
                                                        }
                                                        className=""
                                                        default_currency={
                                                          this.state.currency
                                                        }
                                                      />
                                                    </p>
                                                    <p className="text">
                                                      {
                                                        languageConfig[
                                                          this.state
                                                            .default_lang
                                                        ].savings
                                                      }
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                        </React.Fragment>
                                      ) : (
                                        ""
                                      )}
                                      <div className="social-icons margin-top">
                                        {data.proposal_type == 11 ? (
                                          <FacebookShareButton
                                            key={Math.random()}
                                            className="facebook"
                                            quote={
                                              languageConfig[
                                                this.state.default_lang
                                              ].offer +
                                              ": " +
                                              ReactHtmlParser(
                                                data.mainDealText
                                              ) +
                                              "\n" +
                                              languageConfig[
                                                this.state.default_lang
                                              ].only_merchant_label +
                                              ": " +
                                              data.merchantName
                                            }
                                            url={`${
                                              this.state.siteDomain
                                            }/auction-detail/${
                                              data.dealID
                                            }-${data.merchantName
                                              .toLowerCase()
                                              .trim()
                                              .split(/\s+/)
                                              .join("-")}`}
                                          >
                                            <FacebookIcon
                                              size={25}
                                              round={false}
                                            />
                                          </FacebookShareButton>
                                        ) : (
                                          <FacebookShareButton
                                            key={Math.random()}
                                            className="facebook"
                                            quote={
                                              languageConfig[
                                                this.state.default_lang
                                              ].offer +
                                              ": " +
                                              ReactHtmlParser(
                                                data.mainDealText
                                              ) +
                                              "\n" +
                                              languageConfig[
                                                this.state.default_lang
                                              ].only_merchant_label +
                                              ": " +
                                              data.merchantName
                                            }
                                            url={`${
                                              this.state.siteDomain
                                            }/deals-detail/${
                                              data.dealID
                                            }-${data.merchantName
                                              .toLowerCase()
                                              .trim()
                                              .split(/\s+/)
                                              .join("-")}`}
                                          >
                                            <FacebookIcon
                                              size={25}
                                              round={false}
                                            />
                                          </FacebookShareButton>
                                        )}

                                        {data.proposal_type == 11 ? (
                                          <TwitterShareButton
                                            key={Math.random()}
                                            className="twitter"
                                            quote={ReactHtmlParser(
                                              data.mainDealText
                                            )}
                                            url={`${
                                              this.state.siteDomain
                                            }/auction-detail/${
                                              data.dealID
                                            }-${data.merchantName
                                              .toLowerCase()
                                              .trim()
                                              .split(/\s+/)
                                              .join("-")}`}
                                          >
                                            <TwitterIcon
                                              size={25}
                                              round={false}
                                            />
                                          </TwitterShareButton>
                                        ) : (
                                          <TwitterShareButton
                                            key={Math.random()}
                                            className="twitter"
                                            quote={ReactHtmlParser(
                                              data.mainDealText
                                            )}
                                            url={`${
                                              this.state.siteDomain
                                            }/deals-detail/${
                                              data.dealID
                                            }-${data.merchantName
                                              .toLowerCase()
                                              .trim()
                                              .split(/\s+/)
                                              .join("-")}`}
                                          >
                                            <TwitterIcon
                                              size={25}
                                              round={false}
                                            />
                                          </TwitterShareButton>
                                        )}
                                      </div>
                                      {data.displayTimer == 1 &&
                                        timerOption == "yes" && (
                                          <div className="text-center timer">
                                            <i className="glyphicon glyphicon-time" />{" "}
                                            {data.time_remaining}
                                          </div>
                                        )}
                                    </div>
                                  </Col>
                                </Row>
                              </Carousel.Item>
                            );
                          }
                        })
                      : null}
                  </Carousel>
                </div>
              ) : !isEmpty(this.state.topDeal) &&
                this.state.featured_offer == 1 ? (
                <div className="bg-white slider-container shadow">
                  <Row className="deal-banner">
                    <Col lg={8} md={8} sm={6} xs={12}>
                      {this.state.topDeal.proposal_type == 11 ? (
                        <a
                          onClick={() =>
                            this.state.topDeal.offer_url
                              ? this.context.router.history.push(
                                  `/auction-detail/${this.state.topDeal.offer_url}/${this.state.default_city}`
                                )
                              : this.context.router.history.push(
                                  `/auction-detail/${
                                    this.state.topDeal.dealID
                                  }-${this.state.topDeal.merchantName
                                    .toLowerCase()
                                    .trim()
                                    .split(/\s+/)
                                    .join("-")}/${this.state.default_city}`
                                )
                          }
                        >
                          {!isEmpty(this.state.topDeal.dealImages) ? (
                            <div
                              className="dealSingleimage"
                              style={{
                                backgroundImage: `url(${
                                  this.state.topDeal.dealImages[0].slider_image.includes(
                                    "http://product-images.imshopping.com"
                                  )
                                    ? this.state.topDeal.dealImages[0].slider_image.replace(
                                        "https://d266oi3blg1w2v.cloudfront.net/",
                                        ""
                                      )
                                    : this.state.topDeal.dealImages[0]
                                        .slider_image
                                })`,
                                backgroundPosition: "center",
                                backgroundSize: "contain",
                                backgroundColor: "#fff",
                              }}
                            ></div>
                          ) : (
                            <div className="dealSingleimage">
                              <Image responsive src={noImg} />
                            </div>
                          )}
                        </a>
                      ) : (
                        <a
                          onClick={() =>
                            this.state.topDeal.offer_url
                              ? this.context.router.history.push(
                                  `/deals-detail/${this.state.topDeal.offer_url}/${this.state.default_city}`
                                )
                              : this.context.router.history.push(
                                  `/deals-detail/${
                                    this.state.topDeal.dealID
                                  }-${this.state.topDeal.merchantName
                                    .toLowerCase()
                                    .trim()
                                    .split(/\s+/)
                                    .join("-")}/${this.state.default_city}`
                                )
                          }
                        >
                          {!isEmpty(this.state.topDeal.dealImages) ? (
                            <div
                              className="dealSingleimage"
                              style={{
                                backgroundImage: `url(${
                                  this.state.topDeal.dealImages[0].slider_image.includes(
                                    "http://product-images.imshopping.com"
                                  )
                                    ? this.state.topDeal.dealImages[0].slider_image.replace(
                                        "https://d266oi3blg1w2v.cloudfront.net/",
                                        ""
                                      )
                                    : this.state.topDeal.dealImages[0]
                                        .slider_image
                                })`,
                                backgroundPosition: "center",
                                backgroundSize: "contain",
                                backgroundColor: "#fff",
                              }}
                            ></div>
                          ) : (
                            <div className="dealSingleimage">
                              <Image responsive src={noImg} />
                            </div>
                          )}
                        </a>
                      )}
                    </Col>
                    <Col lg={4} md={4} sm={6} xs={12}>
                      <div className="bannerDeal text-center clearfix">
                        <h2 className="dealname text-center">
                          {ReactHtmlParser(
                            this.state.topDeal.childDealsCount &&
                              this.state.topDeal.childDealsCount > 0
                              ? this.state.topDeal.mainDealText
                              : this.state.topDeal.dealText
                          )}
                        </h2>
                        <div className="merchant merchantname">
                          {this.state.topDeal.useProdName == 0
                            ? this.state.topDeal.merchantName
                            : this.state.topDeal.prodName
                            ? this.state.topDeal.prodName
                            : this.state.topDeal.merchantName}
                          <br />
                          <div className="fonthighlights text-center">
                            <ul>
                              {this.state.topDealHighlights.first && (
                                <li key={Math.random()}>
                                  <i
                                    className="glyphicon glyphicon-check"
                                    style={{ color: this.state.button_color }}
                                  ></i>{" "}
                                  {this.state.topDealHighlights.first}
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                        <div className="deals-price">
                          {!isEmpty(this.state.topDeal.child_deals) ? (
                            multiprice == "0.00" ||
                            this.state.topDeal.offerPrice == "0.00" ? (
                              <span
                                className="price"
                                style={{
                                  display:
                                    this.state.topDeal.proposal_type == 7
                                      ? "none"
                                      : "block",
                                }}
                              >
                                {this.state.topDeal.proposal_type == 6
                                  ? languageConfig[this.state.default_lang]
                                      .proposal_coupon
                                  : languageConfig[this.state.default_lang]
                                      .free_text}
                              </span>
                            ) : this.state.topDeal.proposal_type == 11 &&
                              this.state.topDeal.lastAuctionAmount > 0 ? (
                              <span className="price">
                                <Currency
                                  amount={this.state.topDeal.lastAuctionAmount}
                                  default_lang={this.state.default_lang}
                                  className="price"
                                  default_currency={this.state.currency}
                                />
                              </span>
                            ) : this.state.topDeal.proposal_type == 11 &&
                              this.state.topDeal.lastAuctionAmount == "" &&
                              this.state.topDeal.lastAuctionAmount == null ? (
                              <span className="price">
                                <Currency
                                  amount={this.state.topDeal.offerPrice}
                                  default_lang={this.state.default_lang}
                                  className="price"
                                  default_currency={this.state.currency}
                                />
                              </span>
                            ) : this.state.topDeal.proposal_type != 7 ? (
                              <span className="price">
                                <Currency
                                  amount={
                                    multiprice != ""
                                      ? multiprice
                                      : this.state.topDeal.offerPrice
                                  }
                                  default_lang={this.state.default_lang}
                                  className=""
                                  default_currency={this.state.currency}
                                />
                              </span>
                            ) : null
                          ) : this.state.topDeal.offerPrice == "0.00" ? (
                            <span
                              className="price"
                              style={{
                                display:
                                  this.state.topDeal.proposal_type == 7
                                    ? "none"
                                    : "block",
                              }}
                            >
                              {this.state.topDeal.proposal_type == 6
                                ? languageConfig[this.state.default_lang]
                                    .proposal_coupon
                                : languageConfig[this.state.default_lang]
                                    .free_text}
                            </span>
                          ) : this.state.topDeal.proposal_type == 11 &&
                            this.state.topDeal.lastAuctionAmount > 0 ? (
                            <span className="price">
                              <Currency
                                amount={this.state.topDeal.lastAuctionAmount}
                                default_lang={this.state.default_lang}
                                className="price"
                                default_currency={this.state.currency}
                              />
                            </span>
                          ) : this.state.topDeal.proposal_type == 11 &&
                            this.state.topDeal.lastAuctionAmount == "" &&
                            this.state.topDeal.lastAuctionAmount == null ? (
                            <span className="price">
                              <Currency
                                amount={this.state.topDeal.offerPrice}
                                default_lang={this.state.default_lang}
                                className="price"
                                default_currency={this.state.currency}
                              />
                            </span>
                          ) : this.state.topDeal.proposal_type != 7 ? (
                            <span className="price">
                              <Currency
                                amount={this.state.topDeal.offerPrice}
                                default_lang={this.state.default_lang}
                                className=""
                                default_currency={this.state.currency}
                              />
                            </span>
                          ) : null}
                          <h5 className="merchant text-center">
                            {this.state.topDeal.shortTitle}
                          </h5>
                          {isIE == false && isEdge == false && isMobile ? (
                            this.state.topDeal.proposal_type == 11 ? (
                              <a
                                className="view-button btn btn-deal"
                                style={{
                                  backgroundColor:
                                    this.state.hover &&
                                    this.state.hoverID ==
                                      this.state.topDeal.dealID
                                      ? this.state.mouseover_color
                                      : this.state.button_color,
                                }}
                                data-id={this.state.topDeal.dealID}
                                onMouseEnter={this.hoverOn}
                                onMouseLeave={this.hoverOff}
                                onClick={() =>
                                  this.state.topDeal.offer_url
                                    ? this.context.router.history.push(
                                        `/auction-detail/${this.state.topDeal.offer_url}/${this.state.default_city}`
                                      )
                                    : this.context.router.history.push(
                                        `/auction-detail/${
                                          this.state.topDeal.dealID
                                        }-${this.state.topDeal.merchantName
                                          .toLowerCase()
                                          .trim()
                                          .split(/\s+/)
                                          .join("-")}/${
                                          this.state.default_city
                                        }`
                                      )
                                }
                              >
                                {this.state.topDeal.sold_out == "true"
                                  ? languageConfig[this.state.default_lang]
                                      .auction_ended
                                  : languageConfig[this.state.default_lang]
                                      .auction_view}
                              </a>
                            ) : (
                              <a
                                className="view-button btn btn-deal"
                                style={{
                                  backgroundColor:
                                    this.state.hover &&
                                    this.state.hoverID ==
                                      this.state.topDeal.dealID
                                      ? this.state.mouseover_color
                                      : this.state.button_color,
                                }}
                                data-id={this.state.topDeal.dealID}
                                onMouseEnter={this.hoverOn}
                                onMouseLeave={this.hoverOff}
                                onClick={() =>
                                  this.state.topDeal.offer_url
                                    ? this.context.router.history.push(
                                        `/deals-detail/${this.state.topDeal.offer_url}/${this.state.default_city}`
                                      )
                                    : this.context.router.history.push(
                                        `/deals-detail/${
                                          this.state.topDeal.dealID
                                        }-${this.state.topDeal.merchantName
                                          .toLowerCase()
                                          .trim()
                                          .split(/\s+/)
                                          .join("-")}/${
                                          this.state.default_city
                                        }`
                                      )
                                }
                              >
                                {this.state.topDeal.sold_out == "true"
                                  ? languageConfig[this.state.default_lang]
                                      .sold_out
                                  : languageConfig[this.state.default_lang]
                                      .view}
                              </a>
                            )
                          ) : this.state.topDeal.proposal_type == 11 ? (
                            <a
                              className="view-button btn btn-deal"
                              style={{
                                backgroundColor:
                                  this.state.hover &&
                                  this.state.hoverID ==
                                    this.state.topDeal.dealID
                                    ? this.state.mouseover_color
                                    : this.state.button_color,
                              }}
                              data-id={this.state.topDeal.dealID}
                              onClick={() =>
                                this.state.topDeal.offer_url
                                  ? this.context.router.history.push(
                                      `/auction-detail/${this.state.topDeal.offer_url}/${this.state.default_city}`
                                    )
                                  : this.context.router.history.push(
                                      `/auction-detail/${
                                        this.state.topDeal.dealID
                                      }-${this.state.topDeal.merchantName
                                        .toLowerCase()
                                        .trim()
                                        .split(/\s+/)
                                        .join("-")}/${this.state.default_city}`
                                    )
                              }
                            >
                              {this.state.topDeal.sold_out == "true"
                                ? languageConfig[this.state.default_lang]
                                    .auction_ended
                                : languageConfig[this.state.default_lang]
                                    .auction_view}
                            </a>
                          ) : (
                            <a
                              className="view-button btn btn-deal"
                              style={{
                                backgroundColor:
                                  this.state.hover &&
                                  this.state.hoverID ==
                                    this.state.topDeal.dealID
                                    ? this.state.mouseover_color
                                    : this.state.button_color,
                              }}
                              data-id={this.state.topDeal.dealID}
                              onClick={() =>
                                this.state.topDeal.offer_url
                                  ? this.context.router.history.push(
                                      `/deals-detail/${this.state.topDeal.offer_url}/${this.state.default_city}`
                                    )
                                  : this.context.router.history.push(
                                      `/deals-detail/${
                                        this.state.topDeal.dealID
                                      }-${this.state.topDeal.merchantName
                                        .toLowerCase()
                                        .trim()
                                        .split(/\s+/)
                                        .join("-")}/${this.state.default_city}`
                                    )
                              }
                            >
                              {this.state.topDeal.sold_out == "true"
                                ? languageConfig[this.state.default_lang]
                                    .sold_out
                                : languageConfig[this.state.default_lang].view}
                            </a>
                          )}
                        </div>

                        {!isEmpty(this.state.topDeal.child_deals) ? (
                          this.state.topDeal.proposal_type != 11 ? (
                            <React.Fragment>
                              {this.state.topDeal.showDiscount == "1" &&
                                this.state.topDeal.proposal_type == 7 && (
                                  <div className="text-center">
                                    <div className="valueInfo shadow">
                                      <div className="save">
                                        <p className="value">
                                          {this.state.topDeal.percentageOff}%
                                          off
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              {this.state.topDeal.showDiscount == "1" &&
                                this.state.topDeal.proposal_type != 7 && (
                                  <div className="text-center">
                                    <div className="valueInfo shadow">
                                      <div className="value">
                                        <p className="value">
                                          <Currency
                                            amount={
                                              retailPrice != ""
                                                ? retailPrice
                                                : this.state.topDeal.retailPrice
                                            }
                                            default_lang={
                                              this.state.default_lang
                                            }
                                            className=""
                                            default_currency={
                                              this.state.currency
                                            }
                                          />
                                        </p>
                                        <p className="text">
                                          {
                                            languageConfig[
                                              this.state.default_lang
                                            ].value
                                          }
                                        </p>
                                      </div>

                                      <div className="discount">
                                        <p className="value">
                                          {saving_percent != ""
                                            ? saving_percent
                                            : this.state.topDeal.saving_percent}
                                          %
                                        </p>
                                        <p className="text">
                                          {
                                            languageConfig[
                                              this.state.default_lang
                                            ].discount
                                          }
                                        </p>
                                      </div>

                                      <div className="save">
                                        <p className="value">
                                          <Currency
                                            amount={
                                              saving_amount != ""
                                                ? saving_amount
                                                : this.state.topDeal
                                                    .saving_amount
                                            }
                                            default_lang={
                                              this.state.default_lang
                                            }
                                            className=""
                                            default_currency={
                                              this.state.currency
                                            }
                                          />
                                        </p>
                                        <p className="text">
                                          {
                                            languageConfig[
                                              this.state.default_lang
                                            ].savings
                                          }
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </React.Fragment>
                          ) : (
                            ""
                          )
                        ) : this.state.topDeal.proposal_type != 11 ? (
                          <React.Fragment>
                            {this.state.topDeal.showDiscount == "1" &&
                              this.state.topDeal.proposal_type == 7 && (
                                <div className="text-center">
                                  <div className="valueInfo shadow">
                                    <div className="save">
                                      <p className="value">
                                        {this.state.topDeal.percentageOff} % off
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            {this.state.topDeal.showDiscount == "1" &&
                              this.state.topDeal.proposal_type != 7 && (
                                <div className="text-center">
                                  <div className="valueInfo shadow">
                                    <div className="value">
                                      <p className="value">
                                        <Currency
                                          amount={
                                            this.state.topDeal.retailPrice
                                          }
                                          default_lang={this.state.default_lang}
                                          className=""
                                          default_currency={this.state.currency}
                                        />
                                      </p>
                                      <p className="text">
                                        {
                                          languageConfig[
                                            this.state.default_lang
                                          ].value
                                        }
                                      </p>
                                    </div>

                                    <div className="discount">
                                      <p className="value">
                                        {this.state.topDeal.saving_percent}%
                                      </p>
                                      <p className="text">
                                        {
                                          languageConfig[
                                            this.state.default_lang
                                          ].discount
                                        }
                                      </p>
                                    </div>

                                    <div className="save">
                                      <p className="value">
                                        <Currency
                                          amount={
                                            this.state.topDeal.saving_amount
                                          }
                                          default_lang={this.state.default_lang}
                                          className=""
                                          default_currency={this.state.currency}
                                        />
                                      </p>
                                      <p className="text">
                                        {
                                          languageConfig[
                                            this.state.default_lang
                                          ].savings
                                        }
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </React.Fragment>
                        ) : (
                          ""
                        )}
                        <div className="social-icons margin-top">
                          {this.state.topDeal.proposal_type == 11 ? (
                            <FacebookShareButton
                              key={Math.random()}
                              className="facebook"
                              quote={
                                languageConfig[this.state.default_lang].offer +
                                ": " +
                                ReactHtmlParser(
                                  this.state.topDeal.child_deals
                                    ? this.state.topDeal.mainDealText
                                    : this.state.topDeal.dealText
                                ) +
                                "\n" +
                                languageConfig[this.state.default_lang]
                                  .only_merchant_label +
                                ": " +
                                this.state.topDeal.merchantName
                              }
                              url={`${this.state.siteDomain}/auction-detail/${
                                this.state.topDeal.dealID
                              }-${this.state.topDeal.merchantName
                                .toLowerCase()
                                .trim()
                                .split(/\s+/)
                                .join("-")}`}
                            >
                              <FacebookIcon size={25} round={false} />
                            </FacebookShareButton>
                          ) : (
                            <FacebookShareButton
                              key={Math.random()}
                              className="facebook"
                              quote={
                                languageConfig[this.state.default_lang].offer +
                                ": " +
                                ReactHtmlParser(
                                  this.state.topDeal.child_deals
                                    ? this.state.topDeal.mainDealText
                                    : this.state.topDeal.dealText
                                ) +
                                "\n " +
                                languageConfig[this.state.default_lang]
                                  .only_merchant_label +
                                ": " +
                                this.state.topDeal.merchantName
                              }
                              url={`${this.state.siteDomain}/deals-detail/${
                                this.state.topDeal.dealID
                              }-${this.state.topDeal.merchantName
                                .toLowerCase()
                                .trim()
                                .split(/\s+/)
                                .join("-")}`}
                            >
                              <FacebookIcon size={25} round={false} />
                            </FacebookShareButton>
                          )}

                          {this.state.topDeal.proposal_type == 11 ? (
                            <TwitterShareButton
                              key={Math.random()}
                              className="twitter"
                              quote={ReactHtmlParser(
                                this.state.topDeal.child_deals
                                  ? this.state.topDeal.mainDealText
                                  : this.state.topDeal.dealText
                              )}
                              url={`${this.state.siteDomain}/auction-detail/${
                                this.state.topDeal.dealID
                              }-${this.state.topDeal.merchantName
                                .toLowerCase()
                                .trim()
                                .split(/\s+/)
                                .join("-")}`}
                            >
                              <TwitterIcon size={25} round={false} />
                            </TwitterShareButton>
                          ) : (
                            <TwitterShareButton
                              key={Math.random()}
                              className="twitter"
                              quote={ReactHtmlParser(
                                this.state.topDeal.child_deals
                                  ? this.state.topDeal.mainDealText
                                  : this.state.topDeal.dealText
                              )}
                              url={`${this.state.siteDomain}/deals-detail/${
                                this.state.topDeal.dealID
                              }-${this.state.topDeal.merchantName
                                .toLowerCase()
                                .trim()
                                .split(/\s+/)
                                .join("-")}`}
                            >
                              <TwitterIcon size={25} round={false} />
                            </TwitterShareButton>
                          )}
                        </div>
                        {this.state.topDeal.displayTimer == 1 &&
                          timerOption == "yes" && (
                            <div className="text-center timer">
                              <i className="glyphicon glyphicon-time" />{" "}
                              {this.state.topDeal.time_remaining}
                            </div>
                          )}
                      </div>
                    </Col>
                  </Row>
                </div>
              ) : null}
            </div>
            <div className="container">
              {currentDeals && (
                <Row className="dealflex">
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <Row>{currentDeals}</Row>
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        {this.state.notifications &&
                          this.state.notifications.map(
                            (data, index) =>
                              data.position == "third_position" && (
                                <div
                                  className={
                                    third_position.content_type == "Ads Script"
                                      ? "deal-container ads"
                                      : "deal-container shadow"
                                  }
                                  key={Math.random() + index}
                                >
                                  <React.Fragment>
                                    {data.displayimage != "" ||
                                    data.mobileappdisplay_image != "" ? (
                                      this.state.width > 480 &&
                                      data.remove_image == 1 ? (
                                        <a
                                          href={this.getValidUrl(
                                            data.display_image_link
                                          )}
                                          target="_blank"
                                        >
                                          <Image src={data.displayimage} />
                                        </a>
                                      ) : this.state.width < 480 &&
                                        data.remove_mobile_app_image == 1 ? (
                                        <a
                                          href={this.getValidUrl(
                                            data.display_image_link
                                          )}
                                          target="_blank"
                                        >
                                          <Image
                                            src={data.mobileappdisplay_image}
                                          />
                                        </a>
                                      ) : (
                                        <React.Fragment>
                                          {third_position.content_type ==
                                          "Ads Script" ? (
                                            third_position.scripttype ==
                                            "other" ? (
                                              <ScriptSlot
                                                datas={third_position}
                                              />
                                            ) : (
                                              <UseDfpSlot
                                                datas={third_position}
                                                ids={Math.random()
                                                  .toString(36)
                                                  .substring(2)}
                                                key={Math.random()
                                                  .toString(36)
                                                  .substring(2)}
                                              />
                                            )
                                          ) : data.message != "" ? (
                                            ReactHtmlParser(data.message)
                                          ) : (
                                            ""
                                          )}
                                        </React.Fragment>
                                      )
                                    ) : (
                                      <React.Fragment>
                                        {third_position.content_type ==
                                        "Ads Script" ? (
                                          third_position.scripttype ==
                                          "other" ? (
                                            <ScriptSlot
                                              datas={third_position}
                                            />
                                          ) : (
                                            <UseDfpSlot
                                              datas={third_position}
                                              ids={Math.random()
                                                .toString(36)
                                                .substring(2)}
                                              key={Math.random()
                                                .toString(36)
                                                .substring(2)}
                                            />
                                          )
                                        ) : data.message != "" ? (
                                          ReactHtmlParser(data.message)
                                        ) : (
                                          ""
                                        )}
                                      </React.Fragment>
                                    )}
                                  </React.Fragment>
                                </div>
                              )
                          )}
                      </Col>
                    </Row>
                    {this.state.Optin == 1 && (
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <form className="send-form">
                            <div
                              className="send-email"
                              style={{
                                backgroundColor: this.state.button_color,
                              }}
                            >
                              <h3 class="align-center">
                                {this.state.siteName} Emails
                              </h3>
                              <FormControl
                                type="text"
                                name="sub_email"
                                onChange={this.handleSubscribe}
                                value={this.state.sub_email}
                                placeholder="Email Address"
                                style={{
                                  borderColor: this.state.sub_emailError,
                                }}
                              />
                              <DatePicker
                                onChange={this.onChangeDOBDate}
                                value={this.state.dob}
                                className={this.state.dobError ? "error" : ""}
                              />
                              <FormControl
                                type="text"
                                name="zipcode"
                                onChange={this.handleSubscribe}
                                value={this.state.zipcode}
                                placeholder="Zip Code"
                                style={{ borderColor: this.state.zipcodeError }}
                              />
                              <br />
                            </div>
                            <Button
                              bsStyle="success"
                              type="submit"
                              onClick={this.submitOptinForm}
                              style={this.state.menuBgStyles}
                            >
                              Click Here
                              <i class="glyphicon glyphicon-play"></i>
                            </Button>
                          </form>
                        </Col>
                      </Row>
                    )}
                    {this.state.fb_link != "" && this.state.fb_link != null && (
                      <Row
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <iframe
                            src={this.state.fb_link}
                            style={{ height: "132px" }}
                          ></iframe>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              )}
              <Row className="dealflex">{currentDeals2}</Row>

              {this.state.total > totalDeal ? (
                <Row>
                  <Col
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    onClick={this.pagination}
                    className="text-center"
                  >
                    <a
                      className="btn btn-deal load-more"
                      style={{
                        backgroundColor:
                          this.state.hover && this.state.hoverID == "Load More"
                            ? this.state.mouseover_color
                            : this.state.button_color,
                      }}
                      data-id={"Load More"}
                      onMouseEnter={this.hoverOn}
                      onMouseLeave={this.hoverOff}
                    >
                      {this.state.load_more ? (
                        <React.Fragment>
                          <i
                            class="fa fa-spinner fa-spin"
                            aria-hidden="true"
                          ></i>{" "}
                          {
                            languageConfig[this.state.default_lang]
                              .load_more_deals
                          }
                        </React.Fragment>
                      ) : (
                        languageConfig[this.state.default_lang].load_more_deals
                      )}
                    </a>
                  </Col>
                </Row>
              ) : null}
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
        {this.state.pending_offers == "enable" &&
          !isEmpty(this.state.upDeal) && (
            <div className="container" style={{ padding: "20px" }}>
              {!isEmpty(this.state.topDeal) && (
                <div className="heading" style={this.state.menuBgStyles}>

                  <h2 style={{ color: "#fff" }}>
                    {languageConfig[this.state.default_lang].upcoming_deal}
                  </h2>


                </div>
              )}
              <Row>{upDeal}</Row>
              {this.state.utotal > utotalDeal ? (
                <Row>
                  <Col
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    onClick={this.paginationupdeal}
                    className="text-center"
                  >
                    <a
                      className="btn btn-deal load-more"
                      style={{
                        backgroundColor:
                          this.state.hover && this.state.hoverID == "Load More"
                            ? this.state.mouseover_color
                            : this.state.button_color,
                      }}
                      data-id={"Load More"}
                      onMouseEnter={this.hoverOn}
                      onMouseLeave={this.hoverOff}
                    >
                      {this.state.load_more ? (
                        <React.Fragment>
                          <i
                            class="fa fa-spinner fa-spin"
                            aria-hidden="true"
                          ></i>{" "}
                          {
                            languageConfig[this.state.default_lang]
                              .load_more_deals
                          }
                        </React.Fragment>
                      ) : (
                        languageConfig[this.state.default_lang].load_more_deals
                      )}
                    </a>
                  </Col>
                </Row>
              ) : null}
            </div>
          )}

        {isEmpty(this.state.topDeal) &&
        /*this.state.pending_offers == 'enable' &&*/ isEmpty(
          this.state.upDeal
        ) &&
        isLoading != true ? (
          <React.Fragment>
            <Row>
              <Col lg={12} md={1} sm={12} xs={12}>
                <Image
                  src={
                    this.state.NoRecord ? this.state.NoRecord : noRecordFound
                  }
                  responsive
                  style={{ margin: "auto" }}
                />
                }
              </Col>
            </Row>
            <Modal
              style={{
                fontFamily: this.state.fontFamilies
                  ? this.state.fontFamilies
                  : "",
              }}
              show={
                this.state.total === 0 &&
                isLoading == false &&
                this.state.PopupDealEndsubscrbe == "enable"
                  ? this.state.removePopup
                  : false
              }
              onHide={this.closenotFoundPopup.bind(this)}
            >
              <Modal.Header closeButton>
                <Modal.Title> </Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                <h1>
                  {languageConfig[this.state.default_lang].currently_dont}
                </h1>
                <h4>
                  {languageConfig[this.state.default_lang].hope_more_soon}
                </h4>
                <Form inline className="subscription">
                  <FormGroup controlId="formInlineName">
                    <ControlLabel>
                      {languageConfig[this.state.default_lang].dont_miss_out}:{" "}
                    </ControlLabel>{" "}
                    <FormControl
                      type="text"
                      name="email"
                      onChange={this.handleSubscribe}
                      autoComplete="off"
                      style={{ borderColor: this.state.emailError }}
                    />
                  </FormGroup>{" "}
                  <Button
                    type="submit"
                    style={{
                      backgroundColor:
                        this.state.hover &&
                        this.state.hoverID == "dealSubscribe"
                          ? this.state.mouseover_color
                          : this.state.button_color,
                    }}
                    data-id={"dealSubscribe"}
                    onMouseEnter={this.hoverOn}
                    onMouseLeave={this.hoverOff}
                    className="cursor"
                    onClick={this.submitSubscription}
                  >
                    {languageConfig[this.state.default_lang].send_request}
                  </Button>
                </Form>
              </Modal.Body>
              <Modal.Footer> </Modal.Footer>
            </Modal>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    );
  }
}

// export default Dashboard;

Dashboard.propTypes = {
  currentDealList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  curDeal: state.frontReducer.curDeal,
  error: state.frontReducer.error,
  sending: state.frontReducer.sending,
  siteStatus: state.siteReducer.siteStatus,
  upcomingDeal: state.frontReducer.upcomingDeal,
  subscribeStatus: state.frontReducer.subscribeStatus,
  postupList: state.postupReducer.listPostup,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    currentDealList,
    getSiteStatus,
    upcomingDealList,
    subscribeUser,
    listPostup,
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Dashboard.js